export default __webpack_public_path__ + "locales/tr/FormGallery.json?hash=1bfb2326d62bb6d819569415cfa56d75";